import React from "react";
import Date from "../components/Date_Telederm";

// update log
// FB 4371 DK    03/29/2021    Added to invoke the telederm date component

export default function ByDateTeledermPage(data:any) {
  return <Date  {...data}/>;
}
